import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators, UntypedFormArray, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { FileUploader } from 'ng2-file-upload';
import { CustomTypeAttribute, IGlobals } from 'src/app/globals/custom-types/global-custom-types';
import { Globals, CommonStatus } from 'src/app/globals/globals';
import StoreAPIModel from 'src/app/controller/store/store-api-model';
import { StoreService } from 'src/app/model/store-model/store.service';
import SystemConstants from 'src/app/util/constants/SystemConstants';
import { CommonValidationService, CustomValidatorOptions } from 'src/app/util/service/common-validation.service';
import { GlobalService } from 'src/app/util/service/global.service';
import { environment } from 'src/environments/environment';
import { LocalizationService, TranslationParams } from 'src/app/util/service/internationalization/localization.service';
import { Translations } from 'src/app/util/service/internationalization/translations.service';
import { IInputLocationLocType } from 'src/app/interface/input-location/i-input-location-loc-type';
import { StoreCategoryOption } from 'src/app/controller/store/store-category.interface';
import { AuthService } from 'src/app/model/auth-model/auth.service';
import { UserModelService } from 'src/app/model/user-model/user-model.service';

@Component({
    selector: 'app-store-add-edit-template',
    templateUrl: './store-add-edit-template.component.html',
    styleUrls: ['./store-add-edit-template.component.scss'],
    standalone: false
})
export class StoreAddEditTemplateComponent implements OnInit {
  @Output() storeDetailsSubmit: EventEmitter<StoreAPIModel> = new EventEmitter<StoreAPIModel>();
  @Output() storeFormSkip: EventEmitter<{key: string, skip: boolean}> = new EventEmitter<{key: string, skip: boolean}>();
  @Output() storeFormClosed: EventEmitter<string> = new EventEmitter<string>()
  @Input() isSignUpForm = false;
  @Input() storeDataFromEditSection: StoreAPIModel;
  @Input() isStoreAddForm = true;
  @Input() enabledCancelButton :boolean;
  storeForm: UntypedFormGroup;
  isSubmitted = false;
  isAutoCompleteAddressSelected: boolean;
  isAutoCompleteCitySelected: boolean;
  isAutoCompleteStateSelected: boolean;
  imageCdn = environment.imageCdn.getHost;
  imageBaseUrl = environment.ImageBase;
  isLoggedIn: string;
  placeData: any;
  storeAttributes: CustomTypeAttribute<IGlobals['adminPaginationAttrs'], any>;
  public uploader: FileUploader = new FileUploader({
    url: environment.apiUrl + '/user/upload-images',
  });
  error: string;
  storeId: any;
  @Input() isStoreAddPopup:boolean;
  @Input() merchantUserId: string;
  isBillingAddressSame: boolean = false;
  businessRedemptionCodeInfoTooltip = SystemConstants.STORE_CODE
  private merchantMailingAddress: Record<string, unknown> | null = null;
  private merchantMailingLoc: Record<string, unknown> | null = null;
  constructor(
    private fb: UntypedFormBuilder,
    private storeModelService: StoreService,
    public globals: Globals,
    private ngZone: NgZone,
    private commonValidationService: CommonValidationService,
    public translations:Translations,
    private localizationService: LocalizationService,
    private globalService: GlobalService,
    private authService: AuthService,
    private userModelService: UserModelService,
    private cdr: ChangeDetectorRef,

  ) { this.initializeProperties(); }

  ngOnInit() {
    this.initializeStoreForm();
    this.getInputListenerForUploaderResponse();
    this.watchStoreAddressChanges();
    this.loadMerchantMailingAddress();
    this.isLoggedIn = localStorage.getItem("isLoggedInSuccessfully");

    const isEditMode = !this.isStoreAddForm && !!this.storeDataFromEditSection;
    this.getStoreCategoryList(isEditMode ? () => this.patchStoreData() : undefined);
  }

  initializeProperties() {
    this.storeAttributes = Object.assign({}, this.globals.adminPaginationAttrs);
  }

  getInputListenerForUploaderResponse() {
    this.uploader.onAfterAddingFile = (file: any) => {
      file.withCredentials = false;
    };
    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => {
      const res = JSON.parse(response);
      if (
        res.status === SystemConstants.OKAY_MSG &&
        res.data[0] &&
        res.data[0].filename
      ) {
        this.storeImagesArray(res.data[0].filename);
      } else {
        if (res && res.status === SystemConstants.ERROR) {
        }
      }
    };
  }

  /**
   * This method is used to initilaize the Store info form with controllers.
   */
  initializeStoreForm(): void {
    this.storeForm = this.fb.group({
      storeName: [
        // '', this.commonValidationService.setCustomValidatorMethods({cannotStartWithWhiteSpace: true, minLength:3, maxLength:25}),
        '',  Validators.required
        // this.commonValidationService.uniqueFieldValidator(
        //   this.storeModelService.isStoreUnique, SystemConstants.STORE_NAME,
        //   {thisRef: this.storeModelService})
      ],
      stroeDesc: [
        // '', this.commonValidationService.setCustomValidatorMethods({cannotStartWithWhiteSpace: true, minLength:3, maxLength:250})
        '',  Validators.required
      ],
      businessPhone: [
        '', [Validators.required, Validators.pattern(this.globals.phoneWithHyphenPattern)]
      ],
      billingAddress: [
        // '', this.commonValidationService.setCustomValidatorMethods({cannotStartWithWhiteSpace: true})
        '', Validators.required
      ],
      billingAddress2: [
        // '', this.commonValidationService.setCustomValidatorMethods({cannotStartWithWhiteSpace: true})
        '', Validators.required
      ],
      isBillingAddressSame: [false],
      isBillingAddressFromAddress2: [false],
      isSameAsMailingAddress: [false],
      locationType: [['store'], [Validators.required, this.validateLocationTypeArray()]],
      storeTypeIds: new UntypedFormControl([], Validators.required),
      storeRedeemcode: [
        // '', this.commonValidationService.setCustomValidatorMethods({cannotStartWithWhiteSpace: true, minLength:4, maxLength:6}),
        '', Validators.required
        // this.commonValidationService.uniqueFieldValidator(
        //   this.storeModelService.isStoreUnique, SystemConstants.STORE_REDEEM_CODE,
        //   {thisRef: this.storeModelService})
      ],
      storeAddress: this.fb.group({
        formattedAddress: ['', [Validators.required, this.pleaseSelectValidAddressFromList()]],
        customAddress: ['', this.commonValidationService.setCustomValidatorMethods({cannotStartWithWhiteSpace: true, disableRequired:true})],
        country: ['', [Validators.required]],
        city: ['', [Validators.required]],
        state: ['', [Validators.required]],
        // postalCode: ['', this.commonValidationService.setCustomValidatorMethods({cannotStartWithWhiteSpace: true, minLength:4, maxLength:12})],
        postalCode: ['', Validators.required],
      }),
      storeData: this.fb.group({
        storeImages: this.fb.array([], Validators.required),
      }),
      storeLoc: this.fb.group({
        type: SystemConstants.POINT,
        coordinates: [],
      }),
      status: [CommonStatus.PENDING, [Validators.required]],
      businessHours: this.fb.array([
        this.createBusinessHoursGroup()
      ]),
    });
  }

  get storeDataForm(): UntypedFormGroup {
    return this.storeForm.controls[SystemConstants.STORE_DATA] as UntypedFormGroup;
  }

  /**
   * This is used to get address control from signup form.
   */
  get storeAddressForm(): {[key: string]: AbstractControl;} {
    const addForm = this.storeForm.get(
      SystemConstants.STORE_ADDRESS
    ) as UntypedFormGroup;
    return addForm.controls;
  }

  storeImagesArray(fileName: string) {
    const storeDataGrp = this.storeForm.get(
      SystemConstants.STORE_DATA
    ) as UntypedFormGroup;
    (storeDataGrp.controls[SystemConstants.STORE_IMAGES] as UntypedFormArray).push(
      new UntypedFormControl(fileName)
    );
  }

  closeForm(): void {
    this.storeFormClosed.emit();
  }

  /**
   * This is used to get store category list
   */
  getStoreCategoryList(onLoaded?: () => void) {
    this.storeModelService.getAllStoreCategoriesForDropdown({ status: CommonStatus.ACTIVE }).subscribe(
      (res) => {
        if (res && res.status === SystemConstants.OKAY_MSG) {
          this.storeAttributes.pageItems = this.mapStoreCategoryOptions(res.data);
          onLoaded?.();
        }
      },
      (err) => {
        console.error(err);
       }
    );
  }

  private mapStoreCategoryOptions(data: unknown): StoreCategoryOption[] {
    if (!Array.isArray(data)) {
      return [];
    }
    return data
      .map((item: Record<string, unknown>) => ({
        _id: String(item?.[SystemConstants.ID] ?? ''),
        storeTypeName: String(item?.[SystemConstants.STORE_TYPE_NAME] ?? '').trim(),
      }))
      .filter((item) => item._id && item.storeTypeName)
      .sort((a, b) => a.storeTypeName.localeCompare(b.storeTypeName));
  }

  private normalizeStoreTypeIds(raw: unknown): string[] {
    return [...new Set(this.asCategoryEntries(raw).map((id) => this.toCategoryId(id)).filter(Boolean))];
  }

  private asCategoryEntries(raw: unknown): unknown[] {
    return raw == null ? [] : Array.isArray(raw) ? raw : [raw];
  }

  private toCategoryId(value: unknown): string {
    if (value == null) {
      return '';
    }
    if (typeof value === 'string') {
      const trimmed = value.trim();
      return SystemConstants.MONGO_OBJECT_ID_REGEX.test(trimmed) ? trimmed : '';
    }
    if (typeof value !== 'object') {
      return '';
    }

    const obj = value as Record<string, unknown> & { toHexString?: () => string; toString?: () => string };
    return this.toCategoryId(obj[SystemConstants.MONGO_OID])
      || this.toCategoryId(obj[SystemConstants.ID])
      || (typeof obj.toHexString === SystemConstants.FUNCTION ? this.toCategoryId(obj.toHexString()) : '')
      || (typeof obj.toString === SystemConstants.FUNCTION && obj.toString !== Object.prototype.toString
        ? this.toCategoryId(obj.toString())
        : '');
  }

  private resolveStoreTypeIdsForEdit(raw: unknown): string[] {
    const ids = this.normalizeStoreTypeIds(raw);
    if (ids.length) {
      return ids;
    }

    const categories: StoreCategoryOption[] = this.storeAttributes.pageItems || [];
    return [...new Set(
      this.asCategoryEntries(raw).map((entry) => {
        if (typeof entry === 'string') {
          const name = entry.trim();
          if (!name || SystemConstants.MONGO_OBJECT_ID_REGEX.test(name)) {
            return '';
          }
          return categories.find((item) => item.storeTypeName === name)?._id ?? '';
        }
        if (entry && typeof entry === 'object') {
          const name = String((entry as Record<string, unknown>)[SystemConstants.STORE_TYPE_NAME] ?? '').trim();
          return name ? categories.find((item) => item.storeTypeName === name)?._id ?? '' : '';
        }
        return '';
      }).filter(Boolean)
    )];
  }

  /**
   * This method is used to search google autocomplete address.
   */
  searchGoogleAutocompleteAddress(event: Event) {
    const srcElement = event.srcElement as HTMLInputElement;
    const inputValue = srcElement.value;
    
    // If user is manually typing, clear the autocomplete state
    if (inputValue && inputValue.length > 0) {
      this.placeData = null;
      this.isAutoCompleteAddressSelected = false;
      this.isAutoCompleteCitySelected = false;
      this.isAutoCompleteStateSelected = false;
    }
    
    const loadGoogleMaps = (): Promise<void> => {
      return new Promise((resolve, reject) => {
        if (typeof google !== 'undefined' && google.maps && google.maps.places) {
          resolve();
        } else {
          const checkInterval = setInterval(() => {
            if (typeof google !== 'undefined' && google.maps && google.maps.places) {
              clearInterval(checkInterval);
              resolve();
            }
          }, 100);
          setTimeout(() => {
            clearInterval(checkInterval);
            reject(new Error('Google Maps API failed to load'));
          }, 10000);
        }
      });
    };
    
    loadGoogleMaps().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(srcElement, { types: [SystemConstants.GEOCODE, SystemConstants.ESTABLISHMENT] });
      autocomplete.addListener(SystemConstants.PLACE_CHANGED, () => {
        this.ngZone.run(() => {
          const place: any = autocomplete.getPlace();
          this.placeData = place.formatted_address;
          this.isAutoCompleteAddressSelected = true;
          this.setStoreAddressWithGoogleAddress(place);
          this.storeForm.markAsDirty();
          this.isSubmitted=false
        });
      });
    }).catch(error => console.error(error));
  }

  clearAddressFieldValidation() {
    if (this.formattedAddress && this.storeAttributes && this.storeAttributes.itemArray && this.storeAttributes.itemArray._id && !this.formattedAddress.dirty) {
      this.formattedAddress.setErrors(null);
    }
  }

  /**
   * Handle manual address input - clear autocomplete state and allow manual entry
   */
  handleManualAddressInput(event: Event) {
    const srcElement = event.srcElement as HTMLInputElement;
    const inputValue = srcElement.value;
    
    // Clear autocomplete state when user manually types
    if (inputValue && inputValue.length > 0) {
      this.placeData = null;
      this.isAutoCompleteAddressSelected = false;
      this.isAutoCompleteCitySelected = false;
      this.isAutoCompleteStateSelected = false;
      
      // Clear other address fields if user is manually typing
      if (inputValue.trim().length >= 8) {
        this.storeForm.patchValue({
          storeAddress: {
            city: '',
            state: '',
            postalCode: '',
            country: ''
          }
        });
        
        // Set default coordinates for manual address entry to prevent null coordinates error
        this.storeForm.patchValue({
          storeLoc: {
            coordinates: [0, 0] // Default coordinates for manual entry
          }
        });
      }
    }
    
    // Trigger validation
    this.formattedAddress.updateValueAndValidity();
  }

  /**
   * Handle address field blur event - final validation check
   */
  handleAddressBlur(event: Event) {
    const srcElement = event.srcElement as HTMLInputElement;
    const inputValue = srcElement.value;
    
    // If user has entered a manual address, ensure it's valid
    if (inputValue && inputValue.trim().length >= 8 && !this.placeData) {
      // This is a valid manual address entry
      this.formattedAddress.updateValueAndValidity();
      
      // Try to geocode the manual address to get actual coordinates
      const currentCoordinates = this.storeForm.get('storeLoc.coordinates').value;
      if (!currentCoordinates || currentCoordinates.length === 0) {
        this.geocodeManualAddress(inputValue);
      }
    }
  }

  /**
   * Ensure coordinates are properly set before form submission
   */
  ensureCoordinatesAreSet(): void {
    const currentCoordinates = this.storeForm.get('storeLoc.coordinates').value;
    if (!currentCoordinates || currentCoordinates.length === 0) {
      // Try to geocode the manual address to get actual coordinates
      const formattedAddress = this.storeForm.get('storeAddress.formattedAddress').value;
      if (formattedAddress && formattedAddress.trim().length >= 8) {
        this.geocodeManualAddress(formattedAddress);
      } else {
        // Fallback to default coordinates
        this.storeForm.patchValue({
          storeLoc: {
            coordinates: [0, 0] // Default coordinates for manual entry
          }
        });
      }
    }
  }

  /**
   * Geocode manual address to get actual coordinates
   */
  geocodeManualAddress(address: string): void {
    const loadGoogleMaps = (): Promise<void> => {
      return new Promise((resolve, reject) => {
        if (typeof google !== 'undefined' && google.maps) {
          resolve();
        } else {
          const checkInterval = setInterval(() => {
            if (typeof google !== 'undefined' && google.maps) {
              clearInterval(checkInterval);
              resolve();
            }
          }, 100);
          setTimeout(() => {
            clearInterval(checkInterval);
            reject(new Error('Google Maps API failed to load'));
          }, 10000);
        }
      });
    };
    
    loadGoogleMaps().then(() => {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: address }, (results, status) => {
        if (status === 'OK' && results && results[0]) {
          const location = results[0].geometry.location;
          this.storeForm.patchValue({
            storeLoc: {
              coordinates: [location.lng(), location.lat()]
            }
          });
        } else {
          // Fallback to default coordinates if geocoding fails
          this.storeForm.patchValue({
            storeLoc: {
              coordinates: [0, 0]
            }
          });
        }
      });
    }).catch(error => {
      console.error('Geocoding error:', error);
      // Fallback to default coordinates
      this.storeForm.patchValue({
        storeLoc: {
          coordinates: [0, 0]
        }
      });
    });
  }

  /**
   * This method is used to set User address with google autocomplete.
   * @param place any
   */
  setStoreAddressWithGoogleAddress(place: any) {
    this.resetStoreAddressFrom()
    if (place.address_components && place.address_components.length) {
      if (place.formatted_address) {
        this.storeForm.patchValue({
          storeAddress: { formattedAddress: place.formatted_address },
        });
      }
      let placeData: { types: any[]; long_name: any; };

      for (placeData of place.address_components) {
        this.storeForm.patchValue({
          storeLoc: {
            coordinates: [
              place.geometry.location.lng(),
              place.geometry.location.lat(),
            ],
          },
        });
      
        // console.log( place.geometry.location.lng,place.geometry.location.lat(),"latitute and longitude")
        const addressType = placeData.types[0];
        // console.log(addressType,"addressType")
        if (addressType ==='locality') {
          this.isAutoCompleteCitySelected = true
          this.storeForm.patchValue({
            storeAddress: { city: placeData.long_name },
          });
        }
        if (addressType === SystemConstants.ADMINISTRATIVE_AREA_LEVEL_1) {
          this.isAutoCompleteStateSelected = true
          this.storeForm.patchValue({
            storeAddress: { state: placeData.long_name },
          });
        }
        if (addressType === SystemConstants.COUNTRY) {
          this.storeForm.patchValue({
            storeAddress: { country: placeData.long_name },
          });
        }
        if (addressType === SystemConstants.POSTAL_CODE) {
          this.storeForm.patchValue({
            storeAddress: { postalCode: placeData.long_name },
          });
        }
      }
    }
  }

  resetStoreAddressFrom(){
    this.storeForm && this.storeForm.controls && this.storeForm.controls.storeAddress.reset()
    this.isAutoCompleteCitySelected = false
    this.isAutoCompleteStateSelected = false
    
    // Ensure coordinates are not null after reset
    const currentCoordinates = this.storeForm.get('storeLoc.coordinates').value;
    if (!currentCoordinates || currentCoordinates.length === 0) {
      this.storeForm.patchValue({
        storeLoc: {
          coordinates: [0, 0] // Default coordinates
        }
      });
    }
  }

  patchDataForLocFormGroup(locFormGroupData: IInputLocationLocType): void{
    this.storeForm.patchValue(locFormGroupData);
  }

  patchDataForLocFormGroup2(locFormGroupData: IInputLocationLocType): void{
    this.storeForm.patchValue(locFormGroupData);
  }

  uploadImage(event) {
    this.error = null;
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      this.getHeightWidthImage(file);
      const storeDataGrp = this.storeForm.get(
        SystemConstants.STORE_DATA
      ) as UntypedFormGroup;
      const storeData = (storeDataGrp.controls[
        SystemConstants.STORE_IMAGES
      ] as UntypedFormArray).value;
      this.markStoreImageAsDirty();
      this.removeImageIfExtensionIsNotValid(file);
      this.removeImageIfSizeIsNotValid(file);
      this.removeImageIfLengthIsNotValid(storeData);
      const reader = new FileReader();
      reader.onload = () => {
        this.uploader.uploadAll();
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  pleaseSelectValidAddressFromList(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      
      // If address is selected from autocomplete suggestions, validate it
      if (this.placeData && control.value === this.placeData) {
        this.isSubmitted = true;
        return null; // Valid address from autocomplete
      }
      
      // If user manually typed an address, allow it (minimum 8 characters for manual entry)
      if (control.value && control.value.trim().length >= 2) {
        // Clear placeData to indicate this is a manual entry
        this.placeData = null;
        return null; // Valid manual address
      }
      
      // If address is too short for manual entry and not from autocomplete
      if (control.value && control.value.trim().length < 2) {
        return { pleaseSelectValidAddressFromList: true };
      }
      
      return null;
    };
  }
  getHeightWidthImage(file) {
    const img = new Image();
    img.src = window.URL.createObjectURL(file);
    const width = img.naturalWidth;
    const height = img.naturalHeight;
    window.URL.revokeObjectURL(img.src);
  }
  removeImageIfExtensionIsNotValid(file) {
    if (!this.commonValidationService.isExtensionOfImageValid(file.type)) {
      this.error = SystemConstants.ERROR_MSG_TYPE;
      this.uploader.queue.pop();
      return 0;
    }
  }

  removeImageIfSizeIsNotValid(file) {
    if (this.commonValidationService.isSizeOfImageValid(file.size)) {
      this.error = SystemConstants.ERROR_MSG_SIZE;
      this.uploader.queue.pop();
      return 0;
    }
  }
  removeImageIfLengthIsNotValid(storeData) {
    if (this.commonValidationService.isLengthOfImageValid(storeData.length)) {
      this.error = SystemConstants.ERROR_MSG_LENGTH;
      this.uploader.queue.pop();
      return 0;
    }
  }
  removeStoreImg(itemImage, index) {
    this.error = ''
    const storeDataGrp = this.storeForm.get(
      SystemConstants.STORE_DATA
    ) as UntypedFormGroup;
    (storeDataGrp.controls[SystemConstants.STORE_IMAGES] as UntypedFormArray).removeAt(
      index
    );
    const image = { image: itemImage, storeId: this.storeId };
    this.storeModelService.deleteImage(image).subscribe((res) => { });
    this.storeForm.markAsDirty();
  }

  trimFormControls() {
    this.storeForm.controls.storeName.setValue(this.storeForm.controls.storeName.value.trim());
    this.storeForm.controls.stroeDesc.setValue(this.storeForm.controls.stroeDesc.value.trim());
    this.storeForm.controls.billingAddress.setValue(this.storeForm.controls.billingAddress.value.trim());
    this.storeForm.controls.billingAddress2.setValue(this.storeForm.controls.billingAddress2.value.trim());
    this.storeForm.controls.storeRedeemcode.setValue(this.storeForm.controls.storeRedeemcode.value.trim());
  }

  onStoreDataSubmit(): void {
  this.isSubmitted = true;
  this.ensureCoordinatesAreSet();

  const storeAddr = this.storeForm.get('storeAddress').value;
  this.storeForm.patchValue({
    billingAddress: storeAddr?.formattedAddress || '',
    billingAddress2: storeAddr?.customAddress || '',
  });

  const storeData: StoreAPIModel = this.storeForm.value;
 if (this.storeForm.get('isBillingAddressSame').value) {
    storeData.billingAddress = storeAddr.formattedAddress || '';
  }
  if (this.storeForm.get('isBillingAddressFromAddress2').value) {
    const address2 = this.storeForm.get('storeAddress.customAddress').value;
    storeData.billingAddress2 = address2 || '';
  }

  if (storeData.locationType && Array.isArray(storeData.locationType)) {
    const locationTypeText = storeData.locationType.join(', ');
    const originalDesc = storeData.stroeDesc || '';
    storeData.stroeDesc = `${originalDesc} [Location Type: ${locationTypeText}]`;
  }

  const businessHours = this.getBusinessHoursData();
  storeData.businessHours = businessHours;

  const hasOverlap = this.businessHoursFormArray.controls.some((_, index) =>
    this.hasOverlappingTime(index)
  );

  if (this.storeForm.invalid || hasOverlap || this.hasBusinessHourError()) {
    return; 
  }

  this.storeDetailsSubmit.emit(storeData);
  this.storeForm.markAsPristine();

  this.trimFormControls();
}

hasBusinessHourError(): boolean {
  return this.businessHoursFormArray.controls.some(bh => {
    const days = bh.get('days')?.value;
    const from = bh.get('timeFrom')?.value;
    const to = bh.get('timeTo')?.value;
    const open24 = bh.get('open24Hrs')?.value;

    if (open24) {
      return false;
    }

    return days && days.length > 0 && (!from || !to);
  });
}

  markStoreImageAsDirty(){
    this.getStoreDataToCheckError().markAsDirty();
  }

  getStoreImages() {
    return this.storeDataForm.controls[SystemConstants.STORE_IMAGES].value;
  }
  getStoreDataToCheckError() {
    return this.storeDataForm.controls[SystemConstants.STORE_IMAGES];
  }

  getErrorMessage(formControl: AbstractControl, formControlName: string, maxLength?: number, minLength?: number) {
    return this.commonValidationService.getErrorMessage(formControl, formControlName, maxLength, minLength);
  }

  getCustomErrorMessage(formControl: AbstractControl, formControlName: string, options?: CustomValidatorOptions) {
    return this.commonValidationService.getCustomErrorMessage(formControl, formControlName, options);
  }

  getTranslation(key: string, options?: TranslationParams) {
    return this.localizationService.getTranslation(key, options)
  }

  finalStep(key: string, skip: boolean) {
    this.storeFormSkip.emit({key, skip});
  }

  patchStoreData() {
    if (this.storeDataFromEditSection && !this.isStoreAddForm) {
      // Handle location type conversion for editing
      const storeData = { ...this.storeDataFromEditSection };
      
      // Extract location type from description field if it exists
      if (storeData.stroeDesc) {
        const locationTypeMatch = storeData.stroeDesc.match(/\[Location Type: ([^\]]+)\]/);
        if (locationTypeMatch) {
          const locationTypes = locationTypeMatch[1].split(', ');
          storeData.locationType = locationTypes;
          
          // Remove the location type suffix from description for display
          storeData.stroeDesc = storeData.stroeDesc.replace(/\s*\[Location Type: [^\]]+\]/, '');
        }
      }
      
      // If no location type found in description, default to store
      if (!storeData.locationType || !Array.isArray(storeData.locationType)) {
        storeData.locationType = ['store'];
      }
      
      const getTimeSlotId = (time: string) => {
        if (!time ) return null;
        const found = this.businessHoursTimeSlots.find(ts => ts.name === time);
        return found ? found.id : null;
      };

      const businessHoursForForm = Array.isArray(storeData.businessHours)
        ? storeData.businessHours
            .filter((bh: any) => bh && bh.fromTime && bh.fromTime !== 'Closed')
            .map((bh: any) => {
              const isOpen24 = bh.fromTime === 'AllDayOpen' && bh.toTime === 'AllDayOpen';
              return {
                days: Array.isArray(bh && bh.days) ? bh.days : [],
                timeFrom: isOpen24 ? null : getTimeSlotId(bh && bh.fromTime),
                timeTo: isOpen24 ? null : getTimeSlotId(bh && bh.toTime),
                open24Hrs: isOpen24,
              };
            })
            .filter((bh: any) => bh.days.length && (bh.open24Hrs || (bh.timeFrom && bh.timeTo)))
        : [];
      
      const { merchantData, ...dataToPatch } = storeData;
      delete dataToPatch.businessHours;
      delete dataToPatch.storeTypeIds;

      this.storeForm.patchValue(dataToPatch);
      this.storeForm.controls.storeTypeIds.setValue(
        this.resolveStoreTypeIdsForEdit(storeData.storeTypeIds),
        { emitEvent: false }
      );
      this.resetBusinessHoursFormArray(businessHoursForForm);
      // this.resetUniqueStoreFieldValidation();
      this.setArrayOfStoreImages();
      this.markStoreImageAsDirty();
      this.storeForm.markAsPristine();
      this.placeData = this.storeDataFromEditSection.storeAddress.formattedAddress;
    }
  }

  // resetUniqueStoreFieldValidation() {
  //   this.storeForm.controls.storeName.setAsyncValidators(
  //     this.commonValidationService.uniqueFieldValidator(
  //       this.storeModelService.isStoreUnique, SystemConstants.STORE_NAME,
  //       {thisRef: this.storeModelService, currentValue: this.storeDataFromEditSection.storeName}
  //     ));
  //   this.storeForm.controls.storeName.updateValueAndValidity();

  //   this.storeForm.controls.storeRedeemcode.setAsyncValidators(
  //     this.commonValidationService.uniqueFieldValidator(
  //       this.storeModelService.isStoreUnique, SystemConstants.STORE_REDEEM_CODE,
  //       {thisRef: this.storeModelService, currentValue: this.storeDataFromEditSection.storeRedeemcode}
  //     )
  //   );
  //   this.storeForm.controls.storeRedeemcode.updateValueAndValidity();
  // }

  setArrayOfStoreImages() {
    if (this.storeDataFromEditSection && this.storeDataFromEditSection.storeData && this.storeDataFromEditSection.storeData.storeImages) {
      this.storeDataFromEditSection.storeData.storeImages.forEach(element => {
        this.storeImagesArray(element);
      });
    }
  }

  get formattedAddress() : AbstractControl{
    return this.storeAddressForm.formattedAddress
  }

  get billingAddress(): AbstractControl {
    return this.storeForm.controls.billingAddress;
  }

  get billingAddress2(): AbstractControl {
    return this.storeForm.controls.billingAddress2;
  }

  /**
   * Watch for store address changes and update billing address if checkbox is checked
   */
  loadMerchantMailingAddress(): void {
    const merchantId =
      this.merchantUserId ||
      this.storeDataFromEditSection?.merchantId ||
      this.authService.getUserData()?.data?._id;

    if (!merchantId) {
      return;
    }

    this.userModelService.finduserById({ _id: merchantId }).subscribe(
      (res) => {
        if (res?.status === SystemConstants.OKAY_MSG && res.data) {
          this.merchantMailingAddress = res.data.address || null;
          this.merchantMailingLoc = res.data.loc || null;
          if (this.storeForm.get('isSameAsMailingAddress')?.value) {
            this.fillStoreAddressFromMailingAddress();
          }
        }
      },
      (err) => console.error(err)
    );
  }

  onSameAsMailingAddressChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.checked) {
      this.fillStoreAddressFromMailingAddress();
    } else {
      this.clearStoreAddress();
    }
  }

  private fillStoreAddressFromMailingAddress(): void {
    if (this.merchantMailingAddress) {
      this.storeForm.patchValue({ storeAddress: { ...this.merchantMailingAddress } });
      this.placeData = (this.merchantMailingAddress as { formattedAddress?: string }).formattedAddress || null;
    }
    if (this.merchantMailingLoc) {
      this.storeForm.patchValue({ storeLoc: { ...this.merchantMailingLoc } });
    }
    this.storeForm.markAsDirty();
    this.cdr.detectChanges();
  }

  private clearStoreAddress(): void {
    this.storeForm.patchValue({
      storeAddress: {
        formattedAddress: '',
        customAddress: '',
        country: '',
        city: '',
        state: '',
        postalCode: '',
      },
      storeLoc: {
        type: SystemConstants.POINT,
        coordinates: [],
      },
    });
    this.placeData = null;
    this.storeForm.markAsDirty();
    this.cdr.detectChanges();
  }

  watchStoreAddressChanges(): void {
    // Watch Address 1 changes
    this.storeForm.get('storeAddress.formattedAddress').valueChanges.subscribe(value => {
      const isBillingAddressSame = this.storeForm.get('isBillingAddressSame').value;
      if (isBillingAddressSame) {
        this.storeForm.patchValue({
          billingAddress: value || ''
        }, { emitEvent: false });
      }
    });

    // Watch Address 2 changes
    this.storeForm.get('storeAddress.customAddress').valueChanges.subscribe(value => {
      const isBillingAddressFromAddress2 = this.storeForm.get('isBillingAddressFromAddress2').value;
      if (isBillingAddressFromAddress2) {
        this.storeForm.patchValue({
          billingAddress2: value || ''
        }, { emitEvent: false });
      }
    });
  }

  /**
   * Handle billing address same as store address checkbox
   */
  onBillingAddressSameChange(event: any): void {
    const billingAddressControl = this.storeForm.get('billingAddress');
    
    if (event.target.checked) {
                 // Copy store address to billing address
      const storeAddress = this.storeForm.get('storeAddress').value;
      this.storeForm.patchValue({
        billingAddress: storeAddress.formattedAddress || ''
      });
      // Disable the billing address field
      billingAddressControl.disable();
    } else {
      // Clear the billing address field
      this.storeForm.patchValue({
        billingAddress: ''
      });
      // Enable the billing address field
      billingAddressControl.enable();
    }
  }

  onBillingAddressFromAddress2Change(event: any): void {
    const billingAddress2Control = this.storeForm.get('billingAddress2');
    
    if (event.target.checked) {
     
      
      // Copy address2 to billing address2
      const address2 = this.storeForm.get('storeAddress.customAddress').value;
      this.storeForm.patchValue({
        billingAddress2: address2 || ''
      });
      // Disable the billing address2 field
      billingAddress2Control.disable();
    } else {
      // Clear the billing address2 field
      this.storeForm.patchValue({
        billingAddress2: ''
      });
      // Enable the billing address2 field
      billingAddress2Control.enable();
    }
  }


  /**
   * Handle location type checkbox changes
   */
  onLocationTypeChange(event: any, type: string): void {
    const currentLocationTypes = this.storeForm.get('locationType').value || [];
    
    if (event.target.checked) {
      // Add the location type if not already present
      if (!currentLocationTypes.includes(type)) {
        currentLocationTypes.push(type);
      }
    } else {
      // Remove the location type if present
      const index = currentLocationTypes.indexOf(type);
      if (index > -1) {
        currentLocationTypes.splice(index, 1);
      }
    }
    
    // Ensure at least one location type is selected
    if (currentLocationTypes.length === 0) {
      currentLocationTypes.push('store'); // Default to store
    }
    
    this.storeForm.patchValue({
      locationType: currentLocationTypes
    });
    
    // Mark the form as dirty to enable the update button
    this.storeForm.markAsDirty();
  }

  /**
   * Check if a location type is selected
   */
  isLocationTypeSelected(type: string): boolean {
    const currentLocationTypes = this.storeForm.get('locationType').value || [];
    return currentLocationTypes.includes(type);
  }

  /**
   * Custom validator for location type array
   */
  validateLocationTypeArray(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value || !Array.isArray(value) || value.length === 0) {
        return { required: true };
      }
      return null;
    };
  }

  /**
   * This method is used to format phone number as US format (XXX-XXX-XXXX)
   */
  formatPhoneNumber(event: any): void {
    this.globalService.formatPhoneNumber(event, this.storeForm.get('businessPhone'));  }


  createBusinessHoursGroup() {
    return this.fb.group({
      days: [[]],
      timeFrom: [{ value: null, disabled: true }],
      timeTo: [{ value: null, disabled: true }],
      open24Hrs: [false],
    });
  }

  businessDayValues = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  
  get businessDayLabels(): string[] {
    return this.businessDayValues.map(day => day.charAt(0));
  }
  
  businessHoursTimeSlots = Array.from({ length: 48 }, (_, i) => {
    const hours24 = Math.floor(i / 2);
    const minutes = (i % 2) * 30;
    const period = hours24 >= 12 ? 'PM' : 'AM';
    const hours12 = hours24 === 0 ? 12 : (hours24 > 12 ? hours24 - 12 : hours24);
    
    return {
      id: i + 1,
      name: `${hours12}:${String(minutes).padStart(2, '0')} ${period}`,
      value24: `${String(hours24).padStart(2, '0')}.${String(minutes).padStart(2, '0')}` 
    };
  });

  get businessHoursFormArray(): UntypedFormArray {
    return this.storeForm.get('businessHours') as UntypedFormArray;
  }

  resetBusinessHoursFormArray(businessHours: any[] = []): void {
    const formArray = this.businessHoursFormArray;
    while (formArray.length) formArray.removeAt(0);

    const slots = businessHours.length ? businessHours : [{ days: [], timeFrom: null, timeTo: null }];

    slots.forEach((slot, index) => {
      const days = Array.isArray(slot && slot.days) ? slot.days : [];
      const hasDays = days.length > 0;
      const isOpen24 = !!(slot && slot.open24Hrs);

      formArray.push(this.fb.group({
        days: [days],
        timeFrom: [{ value: (slot && slot.timeFrom) || null, disabled: !hasDays || isOpen24 }],
        timeTo: [{ value: (slot && slot.timeTo) || null, disabled: !hasDays || isOpen24 }],
        open24Hrs: [isOpen24],
      }));

      this.updateTimeFieldsDisabledState(index);
    });
  }

  getBusinessHoursControl(rowIndex: number, path: string) {
    return this.businessHoursFormArray.at(rowIndex).get(path);
  }

  toggleDay(rowIndex: number, dayIndex: number): void {
    const daysControl = this.getBusinessHoursControl(rowIndex, 'days');
    if (!daysControl) return;
    const days = daysControl.value || [];
    const day = this.businessDayValues[dayIndex];
    daysControl.setValue(days.includes(day) ? days.filter((d: string) => d !== day) : [...days, day]);
    
    // Enable/disable time fields based on day selection
    this.updateTimeFieldsDisabledState(rowIndex);
    
    this.storeForm.markAsDirty();
  }

  updateTimeFieldsDisabledState(rowIndex: number): void {
    const timeFromControl = this.getBusinessHoursControl(rowIndex, 'timeFrom');
    const timeToControl = this.getBusinessHoursControl(rowIndex, 'timeTo');
    const open24Control = this.getBusinessHoursControl(rowIndex, 'open24Hrs');
    const hasDays = this.isAnyDaySelected(rowIndex);
    const isOpen24 = !!open24Control?.value;

    if (open24Control && !hasDays && isOpen24) {
      open24Control.setValue(false, { emitEvent: false });
    }

    if (!timeFromControl || !timeToControl) {
      return;
    }

    if (!hasDays) {
      timeFromControl.disable({ emitEvent: false });
      timeToControl.disable({ emitEvent: false });
      timeFromControl.setValue(null, { emitEvent: false });
      timeToControl.setValue(null, { emitEvent: false });
      return;
    }

    if (isOpen24) {
      timeFromControl.disable({ emitEvent: false });
      timeToControl.disable({ emitEvent: false });
      timeFromControl.setValue(null, { emitEvent: false });
      timeToControl.setValue(null, { emitEvent: false });
      return;
    }

    timeFromControl.enable({ emitEvent: false });
    timeToControl.enable({ emitEvent: false });
  }

  onOpen24HrsChange(rowIndex: number): void {
    const open24Control = this.getBusinessHoursControl(rowIndex, 'open24Hrs');
    if (!open24Control) {
      return;
    }

    if (open24Control.value && !this.isAnyDaySelected(rowIndex)) {
      open24Control.setValue(false, { emitEvent: false });
      return;
    }

    this.updateTimeFieldsDisabledState(rowIndex);
    this.storeForm.markAsDirty();
  }

  onBusinessHoursTimeChange(): void {
    this.storeForm.markAsDirty();
  }

  hasOverlappingTime(rowIndex: number): boolean {
    const currentRaw = (this.businessHoursFormArray.at(rowIndex) as UntypedFormGroup).getRawValue();
    const { days = [], timeFrom = null, timeTo = null, open24Hrs: isOpen24 = false } = currentRaw;

    if (!days.length) return false;

    for (let i = 0; i < rowIndex; i++) {
      const otherRaw = (this.businessHoursFormArray.at(i) as UntypedFormGroup).getRawValue();
      const { days: otherDays = [], timeFrom: otherFrom = null, timeTo: otherTo = null, open24Hrs: isOtherOpen24 = false } = otherRaw;

      if (!otherDays.length) continue;
      if (!days.some((day: string) => otherDays.includes(day))) continue;

      if (isOpen24 || isOtherOpen24) {
        return true;
      }

      if (!timeFrom || !timeTo || !otherFrom || !otherTo) continue;

      const isCurrentOvernight = timeTo < timeFrom;
      const isOtherOvernight = otherTo < otherFrom;
      if (isCurrentOvernight && isOtherOvernight) return true;

      if (!isCurrentOvernight && !isOtherOvernight) {
        if ((timeFrom <= otherTo) && (timeTo >= otherFrom)) return true;
        continue;
      }

      if (isCurrentOvernight) {
        if ((timeFrom <= otherTo && 48 >= otherFrom) || (1 <= otherTo && timeTo >= otherFrom)) return true;
      } else {
        if ((otherFrom <= timeTo && 48 >= timeFrom) || (1 <= timeTo && otherTo >= timeFrom)) return true;
      }
    }

    return false;
  }

  isDaySelected(rowIndex: number, dayIndex: number): boolean {
    const daysControl = this.getBusinessHoursControl(rowIndex, 'days');
    const days = daysControl ? (daysControl.value || []) : [];
    return days.includes(this.businessDayValues[dayIndex]);
  }

  isAnyDaySelected(rowIndex: number): boolean {
    const daysControl = this.getBusinessHoursControl(rowIndex, 'days');
    const days = daysControl ? (daysControl.value || []) : [];
    return days.length > 0;
  }

  isDayDisabled(rowIndex: number, dayIndex: number): boolean {
    const day = this.businessDayValues[dayIndex];
    const count = this.businessHoursFormArray.controls
      .filter((_, i) => i !== rowIndex)
      .reduce((acc, control) => {
        const daysControl = this.getBusinessHoursControl(this.businessHoursFormArray.controls.indexOf(control), 'days');
        const days = (daysControl && daysControl.value) || [];
        return acc + (days.includes(day) ? 1 : 0);
      }, 0);
    
    return count >= 2 && !this.isDaySelected(rowIndex, dayIndex);
  }

  addBusinessHoursRow(): void {
    this.businessHoursFormArray.push(this.createBusinessHoursGroup());
    this.storeForm.markAsDirty();
  }

  removeBusinessHoursRow(index: number): void {
    if (this.businessHoursFormArray.length > 1) {
      this.businessHoursFormArray.removeAt(index);
      this.storeForm.markAsDirty();
    }
  }

  getBusinessHoursData(): any[] {
    const getTimeName = (id: number) => {
      const slot = this.businessHoursTimeSlots.find(ts => ts.id === id);
      return slot ? slot.name : null;
    };

    const selectedDaysMap: { [key: string]: { fromTime: string, toTime: string, fromId: number, toId: number }[] } = {};
    let anyDaySelected = false;
    
    this.businessHoursFormArray.controls.forEach(control => {
      const { days = [], timeFrom = null, timeTo = null, open24Hrs = false } = (control as UntypedFormGroup).getRawValue() || {};
      const fromTime = getTimeName(timeFrom);
      const toTime = getTimeName(timeTo);

      if (!days.length) {
        return;
      }

      anyDaySelected = true;

      days.forEach((day: string) => {
        if (!selectedDaysMap[day]) selectedDaysMap[day] = [];

        if (open24Hrs) {
          selectedDaysMap[day].push({
            fromTime: 'AllDayOpen',
            toTime: 'AllDayOpen',
            fromId: 0,
            toId: 0,
          });
          return;
        }

        if (fromTime && toTime && timeFrom && timeTo) {
          const isSameTime = timeFrom === timeTo;
          selectedDaysMap[day].push({
            fromTime: isSameTime ? 'Closed' : fromTime,
            toTime: isSameTime ? 'Closed' : toTime,
            fromId: timeFrom,
            toId: timeTo,
          });
        }
      });
    });

    if (!anyDaySelected) return [];

    const result: any[] = [];
    
    this.businessDayValues.forEach(day => {
      if (selectedDaysMap[day] && selectedDaysMap[day].length) {
        const sortedSlots = selectedDaysMap[day].sort((a, b) => a.fromId - b.fromId);
        
        sortedSlots.forEach(slot => result.push({ days: [day], fromTime: slot.fromTime, toTime: slot.toTime }));
      } else {
        result.push({ days: [day], fromTime: 'Closed', toTime: 'Closed' });
      }
    });

    return result;
  }

}
